import {createSelector} from 'reselect';

const deviceSelector = (state) => (state && state.device) || {};
const deviceTypeSelector = createSelector(deviceSelector, (device) => device.type);

export {deviceSelector, deviceTypeSelector};
